/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_Voice_Agents_Sync_Desc4Inputs */

const en_svc_ai_voice_agents_sync_desc4 = /** @type {(inputs: Svc_Ai_Voice_Agents_Sync_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every call logged with transcript, summary and outcome, synced to your CRM and calendar.`)
};

const ar_svc_ai_voice_agents_sync_desc4 = /** @type {(inputs: Svc_Ai_Voice_Agents_Sync_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`يتم تسجيل كل مكالمة مع النص والملخص والنتيجة، ومزامنتها مع CRM والتقويم.`)
};

const bn_svc_ai_voice_agents_sync_desc4 = /** @type {(inputs: Svc_Ai_Voice_Agents_Sync_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`প্রতিটি কল ট্রান্সক্রিপ্ট, সারাংশ আর ফলাফলসহ লগ করা হয়, আপনার CRM আর ক্যালেন্ডারের সাথে সিঙ্ক হয়।`)
};

const de_svc_ai_voice_agents_sync_desc4 = /** @type {(inputs: Svc_Ai_Voice_Agents_Sync_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jeder Anruf wird mit Transkript, Zusammenfassung und Ergebnis protokolliert und mit CRM und Kalender synchronisiert.`)
};

const es_svc_ai_voice_agents_sync_desc4 = /** @type {(inputs: Svc_Ai_Voice_Agents_Sync_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cada llamada registrada con transcripción, resumen y resultado, sincronizada con su CRM y calendario.`)
};

const fr_svc_ai_voice_agents_sync_desc4 = /** @type {(inputs: Svc_Ai_Voice_Agents_Sync_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chaque appel consigné avec transcription, résumé et résultat, synchronisé avec votre CRM et votre calendrier.`)
};

const pt_svc_ai_voice_agents_sync_desc4 = /** @type {(inputs: Svc_Ai_Voice_Agents_Sync_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cada chamada registada com transcrição, resumo e resultado, sincronizada com o seu CRM e calendário.`)
};

const zh_svc_ai_voice_agents_sync_desc4 = /** @type {(inputs: Svc_Ai_Voice_Agents_Sync_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每次通话附带文字记录、摘要和结果入库，并同步到你的 CRM 和日历。`)
};

const tr_svc_ai_voice_agents_sync_desc4 = /** @type {(inputs: Svc_Ai_Voice_Agents_Sync_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Her çağrı transkript, özet ve sonuçla kaydedilir, CRM ve takviminizle senkronize edilir.`)
};

const ru_svc_ai_voice_agents_sync_desc4 = /** @type {(inputs: Svc_Ai_Voice_Agents_Sync_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Каждый звонок записывается с транскриптом, резюме и исходом, синхронизирован с вашей CRM и календарём.`)
};

const pl_svc_ai_voice_agents_sync_desc4 = /** @type {(inputs: Svc_Ai_Voice_Agents_Sync_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Każda rozmowa logowana z transkryptem, podsumowaniem i wynikiem, zsynchronizowana z CRM i kalendarzem.`)
};

/**
* | output |
* | --- |
* | "Every call logged with transcript, summary and outcome, synced to your CRM and calendar." |
*
* @param {Svc_Ai_Voice_Agents_Sync_Desc4Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_voice_agents_sync_desc4 = /** @type {((inputs?: Svc_Ai_Voice_Agents_Sync_Desc4Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_Voice_Agents_Sync_Desc4Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_voice_agents_sync_desc4(inputs)
	if (locale === "bn") return bn_svc_ai_voice_agents_sync_desc4(inputs)
	if (locale === "de") return de_svc_ai_voice_agents_sync_desc4(inputs)
	if (locale === "es") return es_svc_ai_voice_agents_sync_desc4(inputs)
	if (locale === "fr") return fr_svc_ai_voice_agents_sync_desc4(inputs)
	if (locale === "pt") return pt_svc_ai_voice_agents_sync_desc4(inputs)
	if (locale === "zh") return zh_svc_ai_voice_agents_sync_desc4(inputs)
	if (locale === "tr") return tr_svc_ai_voice_agents_sync_desc4(inputs)
	if (locale === "ru") return ru_svc_ai_voice_agents_sync_desc4(inputs)
	if (locale === "pl") return pl_svc_ai_voice_agents_sync_desc4(inputs)
	return en_svc_ai_voice_agents_sync_desc4(inputs)
});
export { svc_ai_voice_agents_sync_desc4 as "svc_ai-voice-agents_SYNC_desc" }